import { qs } from '@fluorescent/dom';

import { section } from '@/neon';

const sel = {
  toggle: '[data-js-toggle]',
};

section('password', {
  onLoad() {
    this.toggleButton = this.container.querySelector(sel.toggle);
    this.toggleButton.addEventListener('click', e => this.toggleView(e));

    const errors = qs(".storefront-password-form .errors", this.container);

    if (errors) {
      this.toggleView();
    }
  },

  onUnload() {
    this.toggleButton.removeEventListener('click', e => this.toggleView(e));
  },

  toggleView() {
    this.container.classList.toggle('welcome');
  },
});
